export type SalesConditionsUi = {
  minPurchase: string;
  minPurchaseError?: string;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export const initialState: SalesConditionsUi = {
  minPurchase: '',
  cancelDisabled: true,
  saveDisabled: true,
};
